import React, { Component } from 'react'
import { get } from 'lodash'
import { Button } from 'components'
import classnames from 'classnames'
import './styles.sass'
import T from 'types'

interface IProps {
  pharmacist: T.Pharmacist
}

class PharmacistProfile extends Component<IProps> {
  public render() {
    const { pharmacist } = this.props
    const { name, address } = pharmacist
    return (
      <div className="pharmacist-profile block-content">
        <div className="d-flex justify-content-between align-items-center flex-column flex-md-row">
          <div className="text-center text-md-left">
            <div className="pharmacist-name mb-1">{name}</div>
            <div className="pharmacist-address mb-1">
              {get(address, 'address1')}
              <br />
              {get(address, 'address2')}
            </div>
            <div className="pharmacist-address">
              {get(address, 'zipcode')} {get(address, 'city')}
            </div>
          </div>
          <div className="mt-3 mt-md-0 ml-md-2 ml-sm-0">
            <Button classname="text-nowrap">Choisir cette pharmacie</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default PharmacistProfile
